<template>
  <button
    @click="handleBack"
    class="back-button"
    aria-label="Go back"
  >
    <span class="back-arrow">←</span>
    <span class="back-text">Back</span>
  </button>
</template>

<script>
export default {
  name: 'BackButton',
  methods: {
    handleBack() {
      // Check if there's history to go back to
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        // Fallback to welcome page if no history
        this.$router.push('/welcome')
      }
    }
  }
}
</script>

<style scoped>
.back-button {
  position: fixed;
  top: 1rem;
  left: 2rem; /* Aligned with page content sections */
  z-index: 1001;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  color: #667eea;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s;
}

.back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  background: #f8f9ff;
}

.back-button:active {
  transform: translateY(0);
}

.back-arrow {
  font-size: 1.25rem;
  line-height: 1;
}

.back-text {
  font-family: inherit;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .back-button {
    left: 2rem; /* Aligned with page content sections */
    padding: 0.625rem 1rem;
    font-size: 0.875rem;
  }

  .back-text {
    display: none;
  }

  .back-arrow {
    font-size: 1.5rem;
  }
}
</style>
